import { useContext } from "react"
import { IconUsersOutline18 as Users } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "./settings-pages/settings-nav-row"
import { SettingsCardInsetContext } from "./settings-switches/settings-container"

export const MultipleCustomersCard = ({ dimmed }: { dimmed?: boolean }) => {
	const inset = useContext(SettingsCardInsetContext)
	return (
		<div
			className={cn(
				settingsNavGroupClass,
				"mb-4",
				!inset && "sm:mx-0",
				dimmed && "opacity-50",
			)}
		>
			<SettingsNavRow
				icon={Users}
				title="Multiple portals"
				description="Activate the support portal for individual customer portals."
				link="/settings/support-portal"
			/>
		</div>
	)
}
